import React from 'react'
import { images } from "../../constants"

const Logo = () => {
  return (
    <div className='logo'>
        <img src={images.logo} alt="" />
    </div>
  )
}

export default Logo